import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('qztkn');
        const storedUserId = localStorage.getItem('quiz_uid');
        if (storedToken) setToken(storedToken);
        if (storedUserId) setUserId(storedUserId);
        setLoading(false);
    }, []);

    const login = ({ token: newToken, userId: newUserId }) => {
        localStorage.setItem('qztkn', newToken);
        localStorage.setItem('quiz_uid', newUserId);
        setToken(newToken);
        setUserId(newUserId);
    };

    const logout = () => {
        localStorage.removeItem('qztkn');
        localStorage.removeItem('quiz_uid');
        setToken(null);
        setUserId(null);
    };

    return (
        <AuthContext.Provider value={{ token, userId, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}